import { render, staticRenderFns } from "./BlockInvoices.vue?vue&type=template&id=e3de1718&scoped=true"
import script from "./BlockInvoices.vue?vue&type=script&lang=js"
export * from "./BlockInvoices.vue?vue&type=script&lang=js"
import style0 from "./BlockInvoices.vue?vue&type=style&index=0&id=e3de1718&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3de1718",
  null
  
)

export default component.exports